import React, { memo } from 'react';

const KeyIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={20}
      height={20}
      viewBox='0 0 20 20'
      fill='none'
      {...props}
    >
      <path
        d='M17.7633 5.41621L17.5801 5.90231L16.6153 4.9376L17.1876 4.3652C17.2304 4.32234 17.2671 4.27552 17.2976 4.22604L17.2977 4.22597C17.8583 3.52177 17.4791 2.81928 16.8997 2.32031L16.6425 2.73259C16.3433 2.43493 15.855 2.43542 15.5563 2.73396L7.94586 10.3445C6.31042 9.4216 4.19824 9.65628 2.80542 11.0489C1.12996 12.7245 1.12996 15.4409 2.80542 17.1161C4.48081 18.7916 7.19711 18.7916 8.87248 17.1161C10.2653 15.7233 10.5 13.6113 9.577 11.9755L12.1938 9.35897L13.7964 10.9614C14.0954 11.2607 14.5848 11.2604 14.8839 10.9614C15.1826 10.6628 15.6023 10.2974 15.8324 9.94269C16.2173 9.34937 15.7458 9.02007 15.0602 8.29352L14.8657 8.76849L13.825 7.72782L14.984 6.56874L16.5866 8.17132C16.8857 8.47035 17.3751 8.47035 17.6741 8.17132C17.8554 7.99004 18.0366 7.80884 18.2178 7.62766C18.2436 7.60191 18.2671 7.57464 18.2885 7.5463C19.1081 6.74607 18.4943 6.12944 17.7633 5.41621ZM7.58848 15.8321C6.62221 16.7984 5.05571 16.7984 4.08945 15.8321C3.12318 14.8659 3.12318 13.2994 4.08945 12.3332C5.05571 11.3669 6.62221 11.3669 7.58848 12.3332C8.55472 13.2994 8.55472 14.8659 7.58848 15.8321Z'
        fill='#14532D'
      />
      <path
        d='M17.9951 5.64758L16.3925 4.04501L16.9649 3.47269C17.2639 3.17366 17.2639 2.68423 16.9649 2.38512L16.4212 1.84145C16.1222 1.54243 15.6327 1.54243 15.3337 1.84145L7.72314 9.45194C6.08771 8.52909 3.97553 8.76381 2.58271 10.1567C0.907327 11.8319 0.907327 14.5483 2.58271 16.2235C4.25808 17.8991 6.97447 17.8991 8.64985 16.2235C10.0427 14.8307 10.2774 12.7187 9.35437 11.0833L11.9712 8.46647L13.5737 10.0689C13.8728 10.3682 14.3622 10.3682 14.6612 10.0689L15.2049 9.52537C15.5039 9.22636 15.5039 8.73684 15.2049 8.43782L13.6023 6.83523L14.7614 5.67623L16.364 7.27882C16.663 7.57786 17.1524 7.57786 17.4514 7.27882L17.9951 6.73515C18.2941 6.43612 18.2941 5.94662 17.9951 5.64758ZM7.36574 14.9395C6.39958 15.9058 4.833 15.9058 3.86681 14.9395C2.90055 13.9733 2.90055 12.4069 3.86681 11.4406C4.833 10.4744 6.39958 10.4744 7.36574 11.4406C8.33201 12.4069 8.33201 13.9733 7.36574 14.9395Z'
        fill='#22C55E'
      />
      <path
        opacity='0.4'
        d='M9.17562 8.71239C9.17562 8.71239 13.4154 4.1626 14.68 3.05929C15.9444 1.95589 16.2916 2.53862 14.6552 4.15024C13.0188 5.76187 10.4277 8.29084 9.79547 8.8487C9.16326 9.40666 8.7045 9.34467 9.17562 8.71239ZM2.29532 12.8965C2.29532 12.8965 2.33245 15.0659 4.07433 15.7478C5.81613 16.4296 5.31404 16.9875 4.70653 17.0744C4.09911 17.1612 2.66223 16.2727 2.01638 15.0411C1.37053 13.8094 1.7188 12.9336 1.87999 12.7228C2.04116 12.512 2.32631 12.543 2.29532 12.8965Z'
        fill='url(#paint0_linear_8138_160633)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_8138_160633'
          x1='1.64063'
          y1='9.78619'
          x2='15.7588'
          y2='9.78619'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset={1} stopColor='white' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default memo(KeyIcon);
